import { get, post, uploadFile } from "@/util/invitationConfig";

export const GetDictionaryByTypeId = (p) =>
  get("/Dictionary/GetDictionaryByTypeId", p);

export const GetMeetingInviteList = (p) =>
  get("ERPMeeting/GetMeetingInviteList", p);

export const GetSignQRCodeByClueMeeting = (p) =>
  get("ERPMeeting/GetSignQRCodeByClueMeeting", p);

export const GetMeetingBaseStationList = (p) =>
  get("ERPMeeting/GetMeetingBaseStationList", p);

export const AddOrEditReceipt = (p) =>
  post("MeetingInvite/AddOrEditReceipt", p, { silentError: true });

export const AddClueByMeeting = (p) =>
  post("Clue/AddClueByMeeting", p, { silentError: true });

export const UploadAliyunFile = (formData) =>
  uploadFile("UploadFile/UploadAliyunFile", formData);
